<div class="filter-buttons">
  @for (btn of filterButtons; track btn.value) {
    <button
      class="filter-btn"
      [class.active]="statusFilter === btn.value"
      (click)="setStatusFilter(btn.value)">
      <span class="filter-label">{{ btn.labelKey | translate }}</span>
      <span class="filter-count">{{ getStatusCount(btn.value) }}</span>
    </button>
  }
</div>
